import { useState } from 'react'
import { useBulkAcceptShipments, useBulkRejectShipments } from 'apps/marketplace/apiTypes/shipments'

export const useMultiSelectShipments = () => {
  const [acceptedShipments, setAcceptedShipments] = useState<number[]>([])
  const [rejectedShipments, setRejectedShipments] = useState<number[]>([])
  const { loading: acceptRequestPending, mutate: bulkAcceptShipments } = useBulkAcceptShipments({})
  const { loading: rejectRequestPending, mutate: bulkRejectShipments } = useBulkRejectShipments({})
  const bulkRequestPending = acceptRequestPending || rejectRequestPending

  const acceptShipments = async (
    shipmentIds: number[],
    onRequestSuccess: () => void,
    onRequestError: (error: string) => void
  ) => {
    try {
      const { shipments } = await bulkAcceptShipments({ shipmentIds })
      const accepted = shipments
        .filter(shipment => shipment.errors.length === 0)
        .map(shipment => shipment.id)
      const errors = shipments
        .filter(shipment => shipment.errors.length > 0)
        .map(shipment => shipment.errors)
        .flat()
      if (errors.length === 0) {
        onRequestSuccess()
      } else {
        onRequestError(errors.join(', '))
      }
      setAcceptedShipments([...acceptedShipments, ...accepted])
    } catch (err) {
      const message = err.data?.errors ? err.data.errors.join(', ') : err.message
      onRequestError(message)
    }
  }
  const acceptSingleShipment = async (
    shipmentId: number,
    onRequestSuccess: () => void,
    onRequestError: (error: string) => void
  ) => {
    try {
      const { shipments } = await bulkAcceptShipments({ shipmentIds: [shipmentId] })
      const shipment = shipments[0]
      if (shipment.errors.length === 0) {
        setAcceptedShipments([...acceptedShipments, shipment.id])
        onRequestSuccess()
      } else {
        onRequestError(shipment.errors.join(', '))
      }
    } catch (err) {
      const message = err.data?.errors ? err.data.errors.join(', ') : err.message
      onRequestError(message)
    }
  }
  const rejectShipments = async (
    shipmentIds: number[],
    onRequestSuccess: () => void,
    onRequestError: (error: string) => void
  ) => {
    try {
      const { shipments } = await bulkRejectShipments({ shipmentIds })
      const rejected = shipments
        .filter(shipment => shipment.errors.length === 0)
        .map(shipment => shipment.id)
      const errors = shipments
        .filter(shipment => shipment.errors.length > 0)
        .map(shipment => shipment.errors)
        .flat()
      if (errors.length === 0) {
        onRequestSuccess()
      } else {
        onRequestError(errors.join(', '))
      }
      setRejectedShipments([...rejectedShipments, ...rejected])
    } catch (err) {
      const message = err.data?.errors ? err.data.errors.join(', ') : err.message
      onRequestError(message)
    }
  }
  const rejectSingleShipment = async (
    shipmentId: number,
    onRequestSuccess: () => void,
    onRequestError: (error: string) => void
  ) => {
    try {
      const { shipments } = await bulkRejectShipments({ shipmentIds: [shipmentId] })
      const shipment = shipments[0]
      if (shipment.errors.length === 0) {
        setRejectedShipments([...rejectedShipments, shipment.id])
        onRequestSuccess()
      } else {
        onRequestError(shipment.errors.join(', '))
      }
    } catch (err) {
      const message = err.data?.errors ? err.data.errors.join(', ') : err.message
      onRequestError(message)
    }
  }

  return {
    acceptedShipments,
    acceptShipments,
    acceptSingleShipment,
    rejectedShipments,
    rejectShipments,
    rejectSingleShipment,
    bulkRequestPending,
  }
}
